import { cn } from '@portals-platform/ui';
import type * as React from 'react';

interface FormSectionProps {
  id?: string;
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}

export function FormSection({ id, title, description, children, className }: FormSectionProps) {
  return (
    <section id={id} className={cn('border-b border-border px-8 py-6 last:border-b-0', className)}>
      <div className="mb-5 grid grid-cols-1 gap-8 md:grid-cols-[220px_1fr]">
        <div>
          <h3 className="mb-1 text-sm font-semibold text-foreground">{title}</h3>
          {description && (
            <p className="text-[12px] leading-relaxed text-muted-foreground">{description}</p>
          )}
        </div>
        <div />
      </div>
      {children}
    </section>
  );
}
